import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import { articles } from '@/mocks/article';

export default function ArticleList() {
  const articleSchema = articles.map((a) => ({
    '@type': 'Article',
    headline: a.title,
    description: a.excerpt,
    image: a.image,
    datePublished: a.date,
    author: { '@type': 'Person', name: a.author },
    url: `https://www.moguwang.com/article/${a.slug}`,
  }));

  const listPageSchema = {
    '@type': 'ItemList',
    itemListElement: articles.map((a, i) => ({
      '@type': 'ListItem' as const,
      position: i + 1,
      url: `https://www.moguwang.com/article/${a.slug}`,
    })),
  };

  return (
    <>
      <SEOHead
        title="穿搭灵感 - 时尚资讯与穿搭指南 | 蘑菇网"
        description="蘑菇网穿搭灵感板块，为你提供最新时尚资讯、季节穿搭趋势、穿搭技巧指南和美妆护肤攻略。让蘑菇网编辑部带你走在时尚前沿。"
        keywords="蘑菇网穿搭推荐,时尚穿搭指南,穿搭灵感,秋季穿搭趋势,职场穿搭,蘑菇网"
        canonicalUrl="https://www.moguwang.com/articles"
        schema={[listPageSchema, ...articleSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: '穿搭灵感' },
            ]}
          />

          <section className="w-full bg-background-100 py-8 md:py-12">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">穿搭灵感</h1>
              <p className="text-sm text-foreground-500 max-w-xl">最新时尚资讯与穿搭指南，让蘑菇网编辑部带你走在时尚前沿</p>
            </div>
          </section>

          <section className="w-full py-8 md:py-12">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group cursor-pointer rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all"
                  >
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded">{article.category}</span>
                        <span className="text-xs text-foreground-400">{article.date}</span>
                      </div>
                      <h2 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-500 line-clamp-2">{article.excerpt}</p>
                      <div className="mt-3 flex items-center gap-1 text-xs text-primary-500">
                        <span>阅读全文</span>
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}